import React, { useState, useEffect } from "react";
import moment from "moment";

import NormalSms from "./NormalSms";
import NormalSmsForm from "./NormalSmsForm";
import AppointmentScheduled from "./AppointmentScheduled";

import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";

import "./style/sideDrawer.css";
import {
  disableHelpButton,
  enableHelpButton,
} from "../../common/DisableHelpButton/DisableHelpButton";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { Dialog } from "@mui/material";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import useDebounce from "../../ERXViewContainer/common/debounce";

export default function SideDrawer({
  open,
  slugUrl,
  doctorName,
  nextAppointment,
  closeDrawerCallback,
  history,
}) {
  const [isOpen, setOpenDrawer] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [consultationInputFees, setConsultationInputFees] = useState(0);
  const [visibleToPatientFees, setVisibleToPatientFees] = useState(0);
  const [isSlotAvailable, setSlotAvailable] = useState(true);
  const debouncedForFees = useDebounce(consultationInputFees, 500);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    setOpenDrawer(open);
    if (open) {
      disableHelpButton();
    }
    return () => {
      enableHelpButton();
    };
  }, [open]);

  useEffect(() => {
    // TODO: debounce onchange to ensure user stops typing before API is called.
    // TODO: This effect will always be called on page load, need to avoid this first time call.
    const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
    const apiData = {
      doctor_id: userId,
      consultation_fees: consultationInputFees,
    };
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      apiData["clinic_id"] = clinicId;
    }

    afterLoginApiAxios({
      method: "post",
      // url: "/user/get_instant_fees",

      url:
        clinicId !== "" && clinicId !== undefined && clinicId !== null
          ? "/clinic/get-instant-fees"
          : "/user/get_instant_fees",

      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: apiData,
    })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setVisibleToPatientFees(res.data.RequestData.visible_to_patient);
        } else {
          setVisibleToPatientFees(0);
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  }, [debouncedForFees]);

  useEffect(() => {
    if (nextAppointment) {
      const current = moment();
      const dtNextAppointment = moment(
        nextAppointment.appointment_date +
          "T" +
          nextAppointment.appointment_start_time
      );

      let difference = dtNextAppointment.diff(current, "minutes");

      if (difference < 15) {
        setSlotAvailable(false);
      } else {
        setSlotAvailable(true);
      }
    } else {
      setSlotAvailable(true);
    }
  }, [nextAppointment]);

  function onFeesInputChange(inputFees) {
    if (!isNaN(inputFees)) {
      setConsultationInputFees(inputFees);
    } else {
      setConsultationInputFees(0);
      setVisibleToPatientFees(0);
    }
  }

  function onDrawerOpen() {
    setOpenDrawer(true);
  }

  function onDrawerClose() {
    // TODO: change logic for close event callback
    // setOpenDrawer(false);
    // setConsultationInputFees(0);
    // setVisibleToPatientFees(0);
    // setShowForm(false);
    closeDrawerCallback(false);
  }

  function closeBookedCard() {
    setShowForm(true);
  }

  function showFormCallback() {
    setShowForm(true);
  }
  const preventNegativeInput = (event) => {
    const invalidKeys = ["-", "e", "+"];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <Dialog open={isOpen}>
      <div className={"side_drawer_main " + (isOpen ? "active" : "")}>
        <div className="side_drawer_container">
          <div className="side_drawer_verlay"></div>
          <div className="side_drawer_body">
            <div className="side_drawer_close">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAATCAYAAADGWsDDAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAARaADAAQAAAABAAAAEwAAAADuhDkdAAAErElEQVRYCe2Wa2hURxTH9xkiSZFurKJJNa6Sh5tsiKmP0lIrtVY/qIUqIkpdsdpv9kOxQmgrlQREKkULlkJpfGIrVrRQItpHFCGKBsljjUpsa5sa7YcK2ujm3d//uhOu693ErBSC5MC5Z+bMf86d+c85c6/LNSIjDKTMQF5e3hgmu50ChEKhQDAYHO009rT4fGYjRUVFYY/Hs43+DLfbHQiHwzFsLf336+vrLxqcz+c7npmZ+Sf9t4xvuFr2sLuvr6+msbFx92BrLC4ujrD/Oex1jUdgTn+i1+utVhMiNhJoHroNnYrvDBOCwknwaY7X6gzjB4f8KntZzUartOGBlhonpApMRPMsUiBkE46xBHkNpr5uaGj4CXY3018ICaMI/NFAQYfjWFNTU01vb+8arW0gYmyEuITXPFM+s5h7BkKu2jdIP1pSUqISmmn3J7ZJ0xUQqAXMgMRm9CikqhT7RRg676EhVOX3JeTvwPYLC1xGnHdxTMdewO5lDfv7AUNsqGyIaZESJ8ZlL6VEQsyYVQosIMxGWpzeiX8+DL7sNCYfpC3HHEBHg92MvU28rZBQQdsSMHNpHMAfBbMKexjdDmZDHOJigUtY+EH81/CtQ38DuxfMYoNJxWqjThmTjBC9w5ebm+vH+llMzOmlnGY7fmkyUWld4USVbZKdkPAt9oOcnJzK1tbW+7QXKD4YZUE3eozN1mDvoZYwvgUSjvE+YSTfEedZ7Hb0ezlSlcSMIe4cYkUUT4SZDFFf4unu7nb89D4YHvhZUFCQxUamgTqSgFTfn5WVNTvub8KOgogv0Onysfmf0bNq6zOPKUZ/RFXSlhL7BDolPz//GXxPJPaMIVBEwZwIkd/HSXYFAoFeteUYivj9/gmcsJvgl+zz2EgUt1zZepAh+0jXSZSHyuUdTup37L729vbKlpaWDtpTFAe7i7Fd2IckPT19Ko7+34KHBv+Hju4UpbM2NdkpPid7ED3tNEaW3ZGfzY5LGLf6kGONa4yTquAfJ7unp2c+3RNoeUZGxlcag49/ZMF/SMyQXcFPg9R6jT+J2O8Q3rNHseKXbyQxrvVJxlnLwl7hG/28HVBYWDgJ/1J8f9n9pt3c3HyddhsvWWJ8ssx5M9435TGxtLT0ubq6ui4+eSd1tzDnELpQOHy/0r7LvGA0Gr1klKF/Wbj+rpXJKYudEJUMZRuRVUAnYqySYTGfamMAzpMV++mfpP8CczSxi/YnCuAkBN/DvI3MqwT3De3XsSvBVvPyvzWH/6DPwL3I4t7u7Ow8l5aWVoRbGWNKoo937mBeOZizZNRR8Lp7qvC1YcvQlCSREHOpyjLm+Lm2MoWTu0qavsFbG1mcPofH0Y9p/4F9iQCXsUb0xZBawlg5Df1vrIWQBqx++nRhLkMtgYj1NE4zXs39cAd7iv5FcBELwIP7pQKzE9/nECIyf4CQ2o6OjkUGM1SbjBATR8Twrkcyxm0ANuuhjLJJ6Rv4emz+QZuU23hK6hZAx3QvKyvzx2Kx8RDTplJKEtDL10gX9E3KqDMJZlC3ftfJ0F8E1MZFQLJJdvJIjrnJcE+Fn5JWiUQeZzPCCf842BHMCAMPGPgPBj5Bnjq/A3IAAAAASUVORK5CYII="
                alt="X"
                onClick={onDrawerClose}
              />
            </div>
            <div className="side_drawer_header mb-20 px-2">
              <h5>Instant Consultation</h5>
              <p>Enter booking fee and start consultation with patients now</p>
            </div>
            <div className="instant_consultation_amount_cont_overflow px-2">
              <div className="instant_consultation_amount_cont">
                <div className="instant_amount_input mb-10">
                  <input
                    className="rupee_input placeholder_style"
                    type="number"
                    min={0}
                    placeholder="Enter Consultation Fee"
                    onChange={(evt) => onFeesInputChange(evt.target.value)}
                    value={consultationInputFees}
                    onKeyDown={(e) => preventNegativeInput(e)}
                  />
                  <span className="rupee_icon">₹</span>
                </div>
                <div className="cons_fees_amout_cont">
                  <span>Fees seen by Patient : ₹ {visibleToPatientFees}</span>
                  <span className="fee_amout"></span>
                </div>
              </div>
              <div className="share_option_cont">
                <NormalSms
                  showForm={showFormCallback}
                  sms={showForm}
                  isSlot={isSlotAvailable}
                />
              </div>
              {showForm ? (
                <div>
                  <NormalSmsForm
                    slugUrl={slugUrl}
                    name={doctorName}
                    showDrawer={onDrawerOpen}
                    closeDrawer={onDrawerClose}
                    amount={consultationInputFees}
                    history={history}
                  />
                </div>
              ) : (
                ""
              )}
              {!isSlotAvailable && !showForm ? (
                <div>
                  <AppointmentScheduled
                    patientName={
                      nextAppointment ? nextAppointment.patient_name : ""
                    }
                    startTime={
                      nextAppointment
                        ? nextAppointment.appointment_start_time
                        : ""
                    }
                    endTime={
                      nextAppointment
                        ? nextAppointment.appointment_end_time
                        : ""
                    }
                    closeBookedCard={closeBookedCard} // TODO: check existing logic and change
                    appointmentId={
                      nextAppointment ? nextAppointment.appointment_id : ""
                    }
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
